import React from "react";
import { Star } from "lucide-react";

export const Stars = ({ n, size = "w-4 h-4", onPick }) => (
  <div className="flex gap-0.5">
    {[1, 2, 3, 4, 5].map((i) => (
      <button key={i} type="button" disabled={!onPick} onClick={() => onPick?.(i)} className={onPick ? "hover:scale-110 transition-transform" : "cursor-default"} data-testid={onPick ? `star-${i}` : undefined}>
        <Star className={`${size} ${i <= n ? "text-[#D4AF37] fill-[#D4AF37]" : "text-neutral-700"}`} />
      </button>
    ))}
  </div>
);
